import { inject, Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { ConfirmationService } from 'primeng/api';

export interface IHasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

@Injectable({ providedIn: 'root' })
export class UnsavedChangesGuard implements CanDeactivate<IHasUnsavedChanges> {
  private readonly _confirmationService = inject(ConfirmationService);

  canDeactivate(component: IHasUnsavedChanges): Promise<boolean> {
    if (component.hasUnsavedChanges()) {
      return new Promise<boolean>((resolve) => {
        this._confirmationService.confirm({
          message: 'Are you sure you want to leave? You will lose all your progress.',
          header: 'Unsaved Changes',
          closable: false,
          rejectButtonProps: {
            label: 'Cancel',
            severity: 'secondary',
            outlined: true,
          },
          acceptButtonProps: {
            label: 'Confirm',
            severity: 'danger',
          },
          accept: () => {
            resolve(true);
          },
          reject: () => {
            resolve(false);
          },
        });
      });
    }
    return Promise.resolve(true);
  }
}
